import { useState } from "react";
import { TrendingUp, TrendingDown, Minus, Store } from "lucide-react";

export function ItemPriceHistoryCard({ itemPriceHistoryData }) {
  const [search, setSearch] = useState("");
  const items = itemPriceHistoryData || [];

  const filteredItems = items.filter(item =>
    item.produto_nome.toLowerCase().includes(search.toLowerCase())
  );

  const getTrendIcon = (trend) => {
    if (trend === "up") return <TrendingUp size={14} className="text-danger-custom" />;
    if (trend === "down") return <TrendingDown size={14} className="text-primary-custom" />;
    return <Minus size={14} className="text-muted-custom" />;
  };

  const formatDate = (isoDate) => {
    if (!isoDate) return '';
    const [year, month, day] = isoDate.split('-');
    return `${day}/${month}/${year}`;
  };

  return (
    <div className="card custom-card h-100">
      <div className="card-body p-4">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h3 className="h5 fw-semibold mb-0">Histórico de Preço por Item</h3>
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Buscar produtos..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              backgroundColor: 'var(--color-surface-raised)',
              border: '1px solid var(--color-border)',
              color: 'var(--color-text-primary)',
              maxWidth: '200px'
            }}
          />
        </div>

        {items.length === 0 ? (
          <div className="d-flex align-items-center justify-content-center" style={{ height: '200px' }}>
            <p className="text-muted-custom">Nenhuma compra registrada ainda.</p>
          </div>
        ) : filteredItems.length === 0 ? (
          <div className="d-flex align-items-center justify-content-center" style={{ height: '200px' }}>
            <p className="text-muted-custom">Nenhum produto encontrado pra "{search}".</p>
          </div>
        ) : (
          <div className="table-responsive" style={{ maxHeight: '360px', overflowY: 'auto' }}>
            <table className="table table-hover mb-0 table-custom">
              <thead>
                <tr style={{ borderBottom: '1px solid var(--color-border)' }}>
                  <th className="text-muted-custom small fw-semibold border-0 pb-3">Produto</th>
                  <th className="text-muted-custom small fw-semibold border-0 pb-3">Loja</th>
                  <th className="text-muted-custom small fw-semibold border-0 pb-3">Preço Atual</th>
                  <th className="text-muted-custom small fw-semibold border-0 pb-3">Preço/Unidade</th>
                  <th className="text-muted-custom small fw-semibold border-0 pb-3">Variação</th>
                  <th className="text-muted-custom small fw-semibold border-0 pb-3">Última Compra</th>
                </tr>
              </thead>
              <tbody>
                {filteredItems.map((item) => (
                  <tr key={item.produto_id} style={{ borderBottom: '1px solid rgba(45, 55, 72, 0.3)' }}>
                    <td className="border-0 py-3">{item.produto_nome}</td>
                    <td className="border-0 py-3">
                      <div className="d-flex align-items-center gap-2">
                        <Store size={14} className="text-muted-custom" />
                        <span className="text-muted-custom small">{item.store}</span>
                      </div>
                    </td>
                    <td className="fw-semibold border-0 py-3">
                      R${item.current_price.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </td>
                    <td className="text-muted-custom small border-0 py-3">
                      {item.price_per_unit != null
                        ? `R$${item.price_per_unit.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}/${item.unit || 'un'}`
                        : '—'}
                    </td>
                    <td className="border-0 py-3">
                      <div className="d-flex align-items-center gap-2">
                        {getTrendIcon(item.trend)}
                        <span className={`small ${item.trend === 'up' ? 'text-danger-custom' : item.trend === 'down' ? 'text-primary-custom' : 'text-muted-custom'}`}>
                          {item.change_percent != null ? `${item.change_percent > 0 ? '+' : ''}${item.change_percent.toFixed(1)}%` : '—'}
                        </span>
                      </div>
                    </td>
                    <td className="text-muted-custom small border-0 py-3">{formatDate(item.last_purchase)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
